module.exports = __webpack_public_path__ + "img/activity_ico4.08ad21db.png";